<template>
  <div class="page-buy-new-esim">
    <div class="page-buy-new-esim__body">
      <Devices v-model:isShowDevices="isShowDevices" :devices="devices" />
      <PostBuyMetfoneEsim
        :esimIsdns="esimIsdns"
        @is-show="handleShowCheckEsim"
        :packageEsimABA="packageEsimABA"
        :loadingEsim="loadingEsim"
        :loadingPackageEsim="loadingPackageEsim"
        :show-supported-devices="false"
      />
    </div>
  </div>
</template>

<script>
import { NavBar } from "vant";
import { ESIM_ORDER_FLOW } from "@/helpers/esimFlow";
import { mapState } from "vuex";
import Devices from "@/components/devices.vue";
import PostBuyMetfoneEsim from "@/components/post-confirm-buy-metfone-esim.vue";

export default {
  name: "BuyNewMetfoneEsim",
  components: {
    [NavBar.name]: NavBar,
    Devices,
    PostBuyMetfoneEsim,
  },
  inject: ["$bridge"],
  data() {
    return {
      isShowDevices: false,
      devices: null,
      esimIsdns: null,
      packageEsimABA: null,
      loadingEsim: false,
      loadingPackageEsim: false,
    };
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
  },
  async created() {
    this.$store.dispatch("headerStore/setTitle", "esim_buy_new_title");
    if (!this.$store.state.loadingStore.loadingFinished) {
      this.$router.replace("/");
      return;
    }
    if (
      this.$store.state.esimBuyStore.orderDetail?.esimOrderFlow ===
      ESIM_ORDER_FLOW.CHANGE
    ) {
      await this.$store.dispatch("esimBuyStore/clearOrderDetail");
    }
    this.getListSupportDevice();
    this.getRecommendIsdn();
    this.getTelecomPackage();
  },
  watch: {
    $route: {
      handler() {
        this.$store.dispatch("headerStore/setTitle", "esim_buy_new_title");
      },
      immediate: true,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ path: "/home", query: { tab: "buyMetfoneEsim" } });
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    handleShowCheckEsim(value) {
      this.isShowDevices = value;
    },
    async getListSupportDevice() {
      this.devices = null;
      if (!this.defaultParam) return;
      const defaultParam = this.stateAsObject(this.defaultParam);
      const params = defaultParam;

      const res = await this.$store.dispatch(
        "esimMetfoneStore/getListSupportDevice",
        params
      );
      if (res?.data?.errorCode === 0) {
        const result = res.data;
        if (result.supportedDevices?.length > 0) {
          this.devices = result.supportedDevices;
          this.isShowDevices = result.isDisPlay != 0;
        }
      } else if (res?.data) {
        this.$notify({
          code: res.data.errorCode,
          message: res.data.message,
        });
      }
    },
    async getRecommendIsdn() {
      this.esimIsdns = null;
      if (!this.defaultParam) return;
      const params = this.stateAsObject(this.defaultParam);
      this.loadingEsim = true;
      const res = await this.$store.dispatch(
        "esimMetfoneStore/getRecommendIsdn",
        params
      );
      if (res?.data?.errorCode === 0 && res.data.lookupIsdnMobiles) {
        this.esimIsdns = Array.isArray(res.data.lookupIsdnMobiles)
          ? res.data.lookupIsdnMobiles
          : [res.data.lookupIsdnMobiles];
      } else if (res?.data && res.data.errorCode !== 0) {
        this.$notify({
          code: res.data.errorCode,
          message: res.data.message,
        });
      }
      this.loadingEsim = false;
    },
    async getTelecomPackage() {
      this.packageEsimABA = null;
      if (!this.defaultParam) return;
      const params = this.stateAsObject(this.defaultParam);
      this.loadingPackageEsim = true;
      const res = await this.$store.dispatch(
        "esimMetfoneStore/getTelecomPackage",
        params
      );
      if (res?.data?.errorCode === 0 && res.data.packages != null) {
        const p = res.data.packages;
        this.packageEsimABA = Array.isArray(p) ? p : [p];
      } else if (res?.data && res.data.errorCode !== 0) {
        this.$notify({
          code: res.data.errorCode,
          message: res.data.message,
        });
      }
      this.loadingPackageEsim = false;
    },
  },
};
</script>

<style scoped>
.page-buy-new-esim {
  min-height: 100vh;
  background: #eeeeee;
}
.page-buy-new-esim__body {
  padding: 12px 16px 32px;
}
</style>
